<template>
  <div class="latest_news">
    <h2 class="latest_news_title">最新消息</h2>
    <div v-if="noNews">目前無任何最新消息</div>
    <div class="a_piece_of_news">
      <div class="flex_container">
        <div class="news_title">{{singleNews.title}}</div>
        <div class="news_date">{{singleNews.created_at}}</div>
      </div>
      <pre class="news_content">{{singleNews.body}}</pre>
    </div>
    <h3>其他消息</h3>
    <div class="news_list flex_container">
      <div class="news_item" v-for="news in allNews" :key="news.id" @click="viewNews(news.id)">
        <div class="news_title_container flex_container">
          <div class="news_title">{{ news.title }}</div>
          <div class="news_date">{{ news.created_at }}</div>
        </div>
        <pre class="news_content">{{ news.body }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "LatestNews",
  data() {
    return {
      allNews: "",
      singleNews: "",
      noNews: false
    };
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("setViewNewsId", "");
    next();
  },
  created() {
    if (this.$store.getters.getViewNewsId !== "") {
      this.getSingleNews();
    }
    this.getALLNews();
  },
  methods: {
    getSingleNews() {
      window.scrollTo(0, 0);
      let id = this.$store.getters.getViewNewsId;
      axios({
        url: this.$store.getters.getGlobalUrl + `admin/news/${id}`,
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      })
        .then(response => {
          this.singleNews = response.data.data;
        })
        .catch(e => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    getALLNews() {
      axios({
        url: this.$store.getters.getGlobalUrl + "admin/news?number=all",
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      })
        .then(response => {
          this.allNews = response.data.data;
          if (this.allNews.length == 0) {
            this.noNews = true;
          }
        })
        .catch(e => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    viewNews(id) {
      this.$store.dispatch("setViewNewsId", id);
      this.getSingleNews();
    }
  }
};
</script>

<style scoped lang="scss">
.flex_container {
  display: flex;
}
.latest_news {
  padding-top: 80px;
  padding-bottom: 50px;
  width: 80%;
  margin: auto;
  font-size: 17px;
  color: $secondaryDeepColor1;
  text-align: left;
}
.latest_news_title {
  text-align: center;
  color: $primaryDeepColor;
  font-size: 30px;
  font-family: "NotoSerifTC-Bold";
}
.a_piece_of_news {
  .flex_container {
    justify-content: space-between;
  }
  .news_title {
    width: 90%;
    font-weight: 600;
    font-size: 23px;
  }
  .news_date {
    flex: 0 0 auto;
  }
  .news_content {
    white-space: pre-wrap;
  }
}
.news_list {
  @include betweenPhoneTable {
    height: 600px;
    overflow: scroll;
  }
  .news_content {
    white-space: pre-wrap;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
.news_list.flex_container {
  flex-wrap: wrap;
}
.news_item {
  box-sizing: border-box;
  width: 32%;
  margin-right: 2%;
  margin-bottom: 2%;
  border: 1px solid $primaryDeepColor;
  padding: 16px;
  cursor: pointer;
  &:hover {
    background-color: $secondaryColor3;
  }
  @include betweenDesktopTablePro {
    width: 48%;
  }
  @include betweenTableTablePro {
    width: 100%;
  }
  @include betweenTableTablePro {
    margin-right: 0;
  }
}
.news_item:nth-child(2n) {
  @include betweenDesktopTablePro {
    margin-right: 0;
  }
}
.news_item:nth-child(3n) {
  margin-right: 0;
  @include betweenDesktopTablePro {
    margin-right: 2%;
  }
  @include betweenTableTablePro {
    margin-right: 0;
  }
}
.news_title_container.flex_container {
  margin-bottom: 16px;
}
.news_title_container {
  .news_title {
    width: 70%;
    font-weight: 600;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    @include phone {
      width: 65%;
    }
  }
}
</style>
